<script>
import feather from 'feather-icons';
import AppHeader from './components/shared/AppHeader';
import AppFooter from './components/shared/AppFooter';

export default {
	components: { AppHeader, AppFooter },
	data: () => ({
		appTheme: localStorage.getItem('theme') || 'dark',
	}),
	mounted() {
		feather.replace();
		// Keep html class in sync when component mounts
		if (this.appTheme === 'dark') {
			document.documentElement.classList.add('dark');
		} else {
			document.documentElement.classList.remove('dark');
		}
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<!-- Outer wrapper only carries the theme class so children can use dark: prefix -->
	<div :class="appTheme">
		<!-- Inner wrapper owns the actual background -->
		<div class="min-h-screen bg-primary-light dark:bg-primary-dark transition-colors duration-300 relative">
			<!-- Smooth ambient overlay (dark mode) -->
			<div class="fixed inset-0 bg-grid pointer-events-none opacity-0 dark:opacity-100 z-0" />

			<!-- Header -->
			<AppHeader />

			<!-- Page -->
			<main class="relative z-10">
				<router-view v-slot="{ Component }">
					<transition name="fade" mode="out-in">
						<component :is="Component" :key="$route.fullPath" :theme="appTheme" />
					</transition>
				</router-view>
			</main>

			<!-- Scroll to top -->
			<back-to-top visibleoffset="500" right="24px" bottom="24px">
				<div class="w-10 h-10 flex items-center justify-center rounded-full btn-gradient text-white shadow-lg">
					<i data-feather="chevron-up" class="w-4 h-4" />
				</div>
			</back-to-top>

			<!-- Footer -->
			<AppFooter />
		</div>
	</div>
</template>

<style>
#app {
	font-family: 'GeneralSans-Variable', Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.vue-back-to-top {
	line-height: 0;
}

.fade-enter-active {
	animation: coming 0.35s ease-out;
	animation-delay: 0.1s;
	opacity: 0;
}

.fade-leave-active {
	animation: going 0.25s ease-in;
}

@keyframes going {
	from { transform: translateX(0); opacity: 1; }
	to   { transform: translateX(-12px); opacity: 0; }
}

@keyframes coming {
	from { transform: translateX(-12px); opacity: 0; }
	to   { transform: translateX(0); opacity: 1; }
}
</style>
